module.exports = __webpack_public_path__ + "img/new_18.f26dd078.jpg";